import { render, staticRenderFns } from "./placard_apply_for_invoice.vue?vue&type=template&id=d1b2970e&scoped=true"
import script from "./placard_apply_for_invoice.vue?vue&type=script&lang=js"
export * from "./placard_apply_for_invoice.vue?vue&type=script&lang=js"
import style0 from "./placard_apply_for_invoice.vue?vue&type=style&index=0&id=d1b2970e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b2970e",
  null
  
)

export default component.exports